import { Component, OnInit } from '@angular/core';
import { Assunto } from '../assunto.model';
import { ActivatedRoute } from '@angular/router';
import { MensagemService, ProgressoService } from 'maestro-ng';
import { AssuntoService } from '../assunto.service';

@Component({
  selector: 'app-assunto-visualizacao',
  templateUrl: './assunto-visualizacao.component.html',
  styleUrls: ['./assunto-visualizacao.component.css'],
})
export class AssuntoVisualizacaoComponent implements OnInit {
  public assunto: Assunto;
  public tipoAssuntoHierarquia: Assunto[] = [];

  constructor(
    private service: AssuntoService,
    private route: ActivatedRoute,
    private progressoService: ProgressoService,
    private mensagemService: MensagemService,
    private assuntoService: AssuntoService
  ) {}

  ngOnInit(): void {
    this.assunto = {} as Assunto;
    this.route.params.subscribe((params) => {
      if (params['id']) {
        this.assuntoService
          .recuperarPorId(+params['id'])
          .then((assunto) => this.carregarAssunto(assunto))
          .catch((response) => this.mensagemService.addErro('Erro ao carregar o assunto.', response.error));
      }
    });
  }

  public carregarAssunto(assunto: Assunto) {
    this.assunto = assunto;
    this.carregaHierarquia();
  }
  carregaHierarquia() {
    let tipoAssuntoAtual = this.assunto;
    while (true) {
      if (tipoAssuntoAtual.id !== this.assunto.id) {
        this.tipoAssuntoHierarquia.push(tipoAssuntoAtual);
      }
      if (tipoAssuntoAtual.pai === null || tipoAssuntoAtual.pai === undefined) {
        break;
      } else {
        tipoAssuntoAtual = tipoAssuntoAtual.pai;
      }
    }
    this.tipoAssuntoHierarquia.reverse();
  }
  limparHierarquia() {
    this.tipoAssuntoHierarquia = [];
  }
  replaceTextoHierarquia(texto: String) {
    return texto?.trim().replaceAll('/', '-');
  }
}
